import { FC, useState, useEffect } from "react";
import { Table, } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceDetailsModel } from "../MaintenanceModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IMaterialDetailList } from "../MaintenanceType";

export const MaterialTableBox: FC<RouterParamType> = () => {

    const { getSelectedNavState } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const { orderInfo } = detailsInfo

    const { detailMaterialList } = useMaintenanceDetailsModel();
    const [totalPrice, setTotalPrice] = useState<string>("0");
    const [columns, setColumns] = useState<any[]>([])

    const title = <>
        <span style={{ fontSize: 20, fontWeight: 'bold', marginLeft: -15 }}>维修用料</span>
        <span style={{ marginLeft: '50px', fontSize: '14px' }}>
            总金额&nbsp;¥&nbsp;<span style={{ color: 'red', fontSize: '18px' }}>{totalPrice}</span>
            &nbsp;元&nbsp;({detailMaterialList.length}项){" "}
        </span>
    </>

    useEffect(() => {
        let num: number = 0
        let colms: any[] = [];
        detailMaterialList.forEach((item) => {
            num += Number(item.actualAmount)

            const info = orderInfo.materialList?.filter((e: any) => e.id === item.id)?.[0];
            if (info != null) {
                info?.fields?.forEach((e: any) => {
                    item[e.fieldCode] = e.fieldValue
                })

                colms = info?.fields?.map((e: any) => {
                    return {
                        title: e.fieldName,
                        width: e.fieldName.length * 16,
                        align: 'center',
                        dataIndex: e.fieldCode
                    }
                });
            }
        })
        setTotalPrice(num.toFixed(2));
        getColumns(colms);
    }, [detailMaterialList])

    const getColumns = (customerColumns: any[]) => {
        setColumns([...startColumns, ...customerColumns, ...endColumns])
    }

    const startColumns: ColumnsType<IMaterialDetailList> = [
        {
            title: '序号',
            width: 50,
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        },
        {
            title: "商品编号",
            align: "center",
            width: 200,
            dataIndex: "materialCode",
        },
        {
            title: "商品名称",
            align: "center",
            width: 200,
            dataIndex: "materialName",
        },
        {
            title: "领料单号",
            align: "center",
            width: 120,
            dataIndex: "maintainOrderCode",
        },
        {
            title: "品牌",
            align: "center",
            width: 80,
            dataIndex: "brandName",
        },
        {
            title: "单位",
            align: "center",
            width: 80,
            dataIndex: "unitName",
        },
        {
            title: "可用数量",
            align: "center",
            width: 80,
            dataIndex: "availableUseNum",
        },
        {
            title: "已选数量",
            align: "center",
            width: 80,
            dataIndex: "materialNumber",
        },
        {
            title: "单价",
            align: "center",
            width: 80,
            dataIndex: "unitPrice",
        },
        {
            title: "总计",
            align: "center",
            width: 80,
            dataIndex: "materialAmount",
        },
        {
            title: "优惠",
            align: "center",
            width: 80,
            dataIndex: "preferentialAmount",
        },
        {
            title: "折扣",
            align: "center",
            width: 80,
            dataIndex: "materialDiscount",
        },
        {
            title: "总金额",
            align: "center",
            width: 80,
            dataIndex: "actualAmount",
        }];

    const endColumns: ColumnsType<IMaterialDetailList> = [
        {
            title: "备注",
            align: "center",
            width: 200,
            dataIndex: "remark",
        }
    ];


    return (
        <YhBox title={title} style={{ marginBottom: 10, padding: 20 }}>
            <Table
                rowKey={record => record.detailsId as string}
                columns={columns}
                dataSource={detailMaterialList}
                pagination={false}
                scroll={{ x: 'max-content', y: 300 }}
            />
        </YhBox>
    )
}